import React, {useEffect, useState} from "react";
import {useSelector, connect} from "react-redux";
import {Formik} from "formik";
import * as auth from "../../../store/ducks/auth.duck";
import * as i18n from "../../../../_metronic/ducks/i18n"
import {Portlet, PortletBody} from "../../../partials/content/Portlet";
import {TextField, MenuItem, LinearProgress} from '@material-ui/core';
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";
import Resource from "../../../crud/resource";
import Translate, {getDataFromResponse} from "../../../utils/utils";
import Swal from "sweetalert2";
import validator from './validator';
import {getLocaleFromLanguageId} from "../../../../_metronic/i18n/I18nProvider";
import {useIntl} from "react-intl";

const Profile = ({updateUser, setLanguage}) => {
    const currentUser = useSelector(store => store.auth.user);
    const [languages, setLanguages] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const initialValues = {
        first_name: currentUser.first_name || '',
        last_name: currentUser.last_name || '',
        language_id: currentUser.language_id || ''
    };

    const intl = useIntl();


    useEffect(() => {
        const languageResource = new Resource('language');
        languageResource.index().then(response => {
            const {data} = getDataFromResponse(response);
            setLanguages(data);
            setIsLoading(false);
        }).catch(({response: {status}}) => {
            setIsLoading(false);
            Swal.fire({
                icon: 'error',
                text: 'Failed loading languages'
            });
            setIsLoading(false);
        });
    }, []);


    const handleSubmit = (values, {setStatus, setSubmitting, setErrors}) => {
        const userResource = new Resource('user');
        setIsLoading(true);
        userResource.update(values, currentUser.id)
            .then(({data: {message}}) => {
                const user = {...currentUser};
                user.language_id = values.language_id;
                user.first_name = values.first_name;
                user.last_name = values.last_name;
                const locale = getLocaleFromLanguageId(values.language_id);
                updateUser(user);
                setLanguage(locale);
                setSubmitting(false);
                setStatus(intl.formatMessage({id: "PROFILE.FORM.UPDATED"}));
                setIsLoading(false);
                Swal.fire({
                    icon: 'success',
                    text: intl.formatMessage({id: "PROFILE.FORM.UPDATED"})
                });
            })
            .catch((error) => {
                setIsLoading(false);
                const {response: {data: {errors = []}} = {}} = error;
                setSubmitting(false);
                setErrors(errors);
            });
        return false;
    }

    return (
        <div className="kt-form kt-form--label-right">
            <Portlet>
                <PortletBody>
                    <div className="kt-section kt-margin-t-30">
                        <div className="kt-section__body">
                            <div className="form-group">
                                {isLoading && <LinearProgress color="secondary"/>}
                                <Formik
                                    initialValues={initialValues}

                                    onSubmit={handleSubmit}
                                    enableReinitialize={true}
                                >
                                    {({
                                          values,
                                          status,
                                          errors,
                                          touched,
                                          handleChange,
                                          handleBlur,
                                          handleSubmit,
                                          isSubmitting
                                      }) => (
                                        <form
                                            noValidate={true}
                                            autoComplete="off"
                                            className="kt-form"
                                            onSubmit={handleSubmit}
                                        >
                                            {status && (
                                                <div role="alert" className="alert alert-danger">
                                                    <div className="alert-text">{status}</div>
                                                </div>
                                            )}

                                            <TextField
                                                margin="dense"
                                                variant="outlined"
                                                label={<Translate id="PROFILE.FORM.FIRST_NAME"/>}
                                                fullWidth={true}
                                                name="first_name"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values?.first_name || initialValues.first_name}
                                                helpertext={errors?.first_name}
                                                error={Boolean(errors?.first_name)}
                                            >
                                            </TextField>

                                            <TextField
                                                margin="dense"
                                                variant="outlined"
                                                label={<Translate id="PROFILE.FORM.LAST_NAME"/>}
                                                fullWidth={true}
                                                name="last_name"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values?.last_name || initialValues.last_name}
                                                helpertext={errors?.last_name}
                                                error={Boolean(errors?.last_name)}
                                            >
                                            </TextField>

                                            <TextField
                                                select
                                                margin="dense"
                                                variant="outlined"
                                                label={<Translate id="PROFILE.FORM.LANGUAGE"/>}
                                                fullWidth={true}
                                                name="language_id"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values?.language_id || initialValues?.language_id}
                                                helpertext={errors?.language_id}
                                                error={Boolean(errors?.language_id)}
                                            >

                                                <MenuItem key='default' value=''>
                                                    {'Select Language'}
                                                </MenuItem>
                                                {languages.map(language => (
                                                    <MenuItem key={`${language.id}`} value={`${language.id}`}>
                                                        {language.name}
                                                    </MenuItem>
                                                ))}

                                            </TextField>

                                            <div className="kt-login__actions mt-3">
                                                <button
                                                    type="submit"
                                                    disabled={isSubmitting || Object.is(initialValues, values)}
                                                    className={`btn btn-success btn-elevate kt-add-user__save  kt-login__btn-primary`}
                                                >
                                                    <Translate id="DIALOG.FORM.BUTTON.UPDATE"/>
                                                </button>
                                            </div>
                                        </form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </PortletBody>
            </Portlet>
        </div>
    );
};

export default injectIntl(withRouter(
    connect(
        null,
        {...auth.actions, ...i18n.actions}
    )(Profile))
);
